<template>
  <div class="about">
    <div v-if="(!challenges || challenges.length < 1) && loaded" class="text-sm-center">
      <div class="user-welcome-text">
        <h3 class="text-xs-center">There are currently no challenges available. <br>Please check that you have been registered for a challenge with your facilitator.</h3>
      </div>
      <div class="text-xs-center mt-3">
        <v-btn
               @click="checkAgain"
               color="primary"
        >Check Again</v-btn><br><br><br><br><br><br>
        <a href="#" @click.prevent="confirm_logout = true" class="pt-5">Logout</a>
      </div>
    </div>
    <div v-if="challenges && challenges.length > 0 && loaded">
      <h3 class="user-welcome-text text-xs-center">Please select which challenge you would like to join</h3>
      <div class="text-xs-center mt-3">
        <div class="mx-5 d-flex"
                v-for="ch in challenges"
                :key="ch.id"
                @click="selectChallenge(ch)"
        >
          <v-img
                 :src="'/img/challenge/' + ch.id + '/challenge_select.jpeg'"
                 class="grey lighten-2 mb-2"
                 @click="selectChallenge(ch)"
                 style="width: 50%; height: 50%; cursor: pointer"
          >
            <template v-slot:placeholder>
              <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </div>

        <!--<v-btn
                v-for="ch in challenges"
                :key="ch.id"
                @click="selectChallenge(ch)"
                color="primary"
        >{{ ch.name }}</v-btn>--> <br><br><br><br><br>
        <a href="#" @click.prevent="confirm_logout = true" class="pt-5">Logout</a>
      </div>
    </div>

    <v-dialog
            v-model="confirm_logout"
            max-width="290"
            persistent
    >
      <v-card>
        <v-card-title class="headline">Logout</v-card-title>

        <v-card-text>
          Are you sure you want to logout?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
                  color="primary lighten-1"
                  text
                  @click="confirm_logout = false"
          >
            No
          </v-btn>

          <v-btn
                  color="primary lighten-1"
                  text
                  @click="logout"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

  import { mapState } from 'vuex'
  export default {
    mounted() {
      var that = this
      this.$store.dispatch('challenge/getChallenges').then(() => that.loaded = true)
    },
    data () {
      return {
        loaded: false,
        confirm_logout: false
      }
    },
    methods: {
      logout () {
        this.$store.dispatch('auth/logout')
      },
      selectChallenge (challenge) {
        //this.challenge = challenge
        this.$store.dispatch('challenge/selectChallenge', challenge.id)
      },
      checkAgain () {
        window.location.reload()
        //this.$store.dispatch('challenge/getChallenges')
      }
    },
    computed: {
      ...mapState({
        challenges: state => state.challenge.challenges
      }),
    }
  }
</script>

